<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">HGS Numarasi</label>
            <v-validator :errors="errors" parameter="HGSNumber" :watch="value.HGSNumber">
                <input
                    type="text"
                    class="form-control"
                    placeholder="HGS Numarasi"
                    :value="value.HGSNumber"
                    maxlength="10"
                    @input="onHGSNumberInput"
                >
            </v-validator>
        </div>

        <div class="col-12 mb-1">
            <label class="form-label">Baslangic Tarihi</label>
            <v-validator :errors="errors" parameter="StartDate" :watch="value.StartDate">
                <v-date-picker v-model="value.StartDate" placeholder="Baslangic Tarihi" style="width: 100%;"/>
            </v-validator>
        </div>

        <div class="col-12 mb-1" v-if="editing">
            <label class="form-label">Bitis Tarihi</label>
            <v-validator :errors="errors" parameter="EndDate" :watch="value.EndDate">
                <v-date-picker v-model="value.EndDate" placeholder="Bitis Tarihi" style="width: 100%;"/>
            </v-validator>
        </div>

        <div class="col-12 mb-1">
            <label class="form-label">HGS Sinifi</label>
            <v-validator :errors="errors" parameter="HGSClass" :watch="value.HGSClass">
                <v-select
                    v-model="value.HGSClass"
                    placeholder="HGS Sinifi Seciniz"
                    :options="hgsClasses"
                    label="Text"
                    :reduce="item => item.Value"
                />
            </v-validator>
        </div>

        <div class="col-12 mb-1">
            <label class="form-label">HGS Arac Tipi</label>
            <v-validator :errors="errors" parameter="HGSVehicleClassType" :watch="value.HGSVehicleClassType">
                <v-select
                    v-model="value.HGSVehicleClassType"
                    placeholder="HGS Arac Tipi Seciniz"
                    :options="hgsVehicleTypes"
                    label="Text"
                    :reduce="item => item.Value"
                />
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlateHGSClassificationCreateOrUpdate',
    components: {},
    props: {
        value: { type: Object, required: true },
        errors: { type: Object, default: () => ({}) },
        editing: { type: Boolean, default: false },
        hgsClasses: { type: Array, default: () => [] },
        hgsVehicleTypes: { type: Array, default: () => [] }
    },
    methods: {
        onHGSNumberInput(event) {
            this.value.HGSNumber = this.normalizeHGSNumber(event?.target?.value)
        },
        normalizeHGSNumber(value) {
            if (!value) return null
            const normalizedValue = value.toString().trim().replace(/\s+/g, '').toUpperCase().slice(0, 10)
            return normalizedValue || null
        }
    }
}
</script>

<style>
</style>
